module.exports = __webpack_public_path__ + "static/img/XMWT_Color.fbbc33f3.jpg";